import { render, staticRenderFns } from "./SfGroupedProductItem.vue?vue&type=template&id=ab017e8a&"
import script from "./SfGroupedProductItem.vue?vue&type=script&lang=js&"
export * from "./SfGroupedProductItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports